import type { PagesOptions } from '@auth/core/types';
import { NextResponse } from 'next/server';

export const nextAuthPageOptions = {
  signIn: '/auth/login',
} satisfies Partial<PagesOptions>;

export async function noAuthResponse() {
  return NextResponse.json({ message: 'Not authenticated', code: 401 }, { status: 401 });
}
